import { render, staticRenderFns } from "./Borders.vue?vue&type=template&id=6c85ef7c&"
import script from "./Borders.vue?vue&type=script&lang=js&"
export * from "./Borders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports